import moment from 'moment';
export var setTimeToMidDay = function setTimeToMidDay(date) {
  return moment(date).set({
    hour: 12,
    minute: 0,
    second: 0,
    milliseconds: 0
  }).toDate();
};